export default function Footer() {
    return (
        <div className="footer-container">
            <h5>&copy; 2025 by Tang Huyming, Tiangkimhong Hoeu, and Kimsean Bun. All Rights Reserved</h5>

            <div className="address-container">
                <h2>Reach Out To Us: </h2>
                <p><strong>Address</strong>: #278H, Street 201R, Kroalkor Village, Sangkat Kilometer 6, Khan Russey Keo, Phnom Penh, Cambodia</p>
                <p><strong>Email</strong>: <a href="mailto:triviabonanza@aupp.edu.kh">triviabonanza@aupp.edu.kh</a></p>
                <p><strong>Telephone</strong>: <a href="tel+85515674833">(+855) 15 674 833</a></p>
            </div>
        </div>
    );
}